// eslint-disable-next-line
export function getErrorMessage(err: unknown): string {
  if (err == null) return 'An unknown error occurred';
  if (typeof err === 'string') return err;
  if (typeof err === 'number') return `Error code: ${err}`;
  // eslint-disable-next-line
  const obj: any = err;

  if ('error' in obj && obj.error && obj.error !== err) {
    return getErrorMessage(obj.error);
  }

  for (const key of ['cause', 'originalError', 'innerError']) {
    if (obj[key]) {
      return getErrorMessage(obj[key]);
    }
  }

  if (obj.isAxiosError) {
    const data = obj.response?.data;
    if (data) {
      if (typeof data.error === 'string') return data.error;
      if (typeof data.message === 'string') return data.message;
      if (Array.isArray(data.errors) && data.errors.length > 0) {
        const first = data.errors[0];
        if (first && typeof first.message === 'string') {
          return first.message;
        }
      }
    }
    return (
      obj.message ||
      (obj.response?.status
        ? `Network Error (${obj.response.status})`
        : 'Network Error')
    );
  }

  if (typeof Response !== 'undefined' && obj instanceof Response) {
    return obj.statusText || `HTTP error ${obj.status}`;
  }

  if (Array.isArray(obj.errors) && obj.errors.length > 0) {
    const first = obj.errors[0];
    if (first && typeof first.message === 'string') {
      return first.message;
    }
  }

  if (obj instanceof Error) {
    return obj.message;
  }

  for (const prop of [
    'message',
    'error_description',
    'error',
    'detail',
    'title',
    'statusText',
    'details',
  ]) {
    if (typeof obj[prop] === 'string') {
      return obj[prop];
    }
  }

  if (typeof obj.status === 'number') {
    return `Error ${obj.status}`;
  }

  try {
    return JSON.stringify(obj);
  } catch {
    return 'An unknown error occurred';
  }
}
